"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buy = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const config_1 = require("../config/config");
const constants_1 = require("../constants");
const errorMessages_1 = require("../errorMessages");
const types_1 = require("../types");
//todo make a buy at listed price method
/**
 * Buys a listed token for a specified price as long as its above the price for which is was listed
 * @param buyArguments {@link BuyArgs}
 * @returns contract call to be passed to @mintbase-js/sdk execute method
 */
const buy = (args) => {
    const { contractAddress = config_1.mbjs.keys.contractAddress, tokenId, referrerId = null, marketId = config_1.mbjs.keys.marketAddress, price, affiliateAccount } = args;
    if (contractAddress == null) {
        throw new Error(errorMessages_1.ERROR_MESSAGES.CONTRACT_ADDRESS);
    }
    if (args.ftAddress) {
        if (!Object.values(config_1.mbjs.keys.ftAddresses).includes(args.ftAddress)) {
            throw new Error(errorMessages_1.ERROR_MESSAGES.UNSUPPORTED_FT);
        }
        return {
            contractAddress: args.ftAddress,
            args: {
                receiver_id: marketId || config_1.mbjs.keys.marketAddress,
                amount: price,
                msg: JSON.stringify({
                    nft_contract_id: contractAddress || config_1.mbjs.keys.contractAddress,
                    token_id: tokenId,
                }),
            },
            methodName: types_1.FT_METHOD_NAMES.FT_TRANSFER_CALL,
            gas: constants_1.MAX_GAS,
            deposit: constants_1.ONE_YOCTO,
        };
    }
    return {
        contractAddress: marketId || config_1.mbjs.keys.marketAddress,
        args: {
            nft_contract_id: contractAddress || config_1.mbjs.keys.contractAddress,
            token_id: tokenId,
            referrer_id: affiliateAccount || referrerId,
        },
        methodName: types_1.MARKET_METHOD_NAMES.BUY,
        gas: constants_1.MAX_GAS,
        deposit: price,
    };
};
exports.buy = buy;
//# sourceMappingURL=buy.js.map